






































import { Component, Vue, Prop } from "vue-property-decorator";
import { AppContainer, TYPES } from "@/app/index";
import { IEntityList } from "@/interfaces";
import { VisitourService, AppointmentService } from "@/services";
import { DataSet } from "@/models";

@Component
export default class RescheduleDateInformation extends Vue {
  @Prop()
  private reference!: string;
  private AppointmentService: AppointmentService = AppContainer.get<
    AppointmentService
  >(TYPES.Services.AppointmentService);
  public options: Array<any> = [];
  public selected: Date | null = null;
  public loading: boolean = false;

  public created(): void {
    this.loading = true;
    this.AppointmentService.GetSuggestions(this.reference)
      .then((response) => {
        if (response.data.Appointments.length > 0) {
          this.options = response.data.Appointments.map(function (appointment) {
            return {
              value: appointment.Date,
              text: new Date(appointment.Date).toLocaleDateString("en-GB"),
            };
          });
        } else {          
          this.$bvModal.msgBoxOk("Sorry, we can't find you a different date. Please call us on 0345 072 4387 to talk to our planning team.",
            {
              title: "Unable to reschedule.",
              size: "lg",
              centered: true,
            })
            .then((value) => {
            this.$bvModal.hide("RescheduleDateModal");
          });          
        }
      })
      .catch((error) => {
        this.$bvModal
          .msgBoxOk(error.response.data, 
          {
            title: "Unable to reschedule.",
            size: "lg",
            centered: true,
          })
          .then((value) => {
            this.$bvModal.hide("RescheduleDateModal");
          });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private confirmSuggestedAppointment(): any {
    this.AppointmentService.ConfirmSuggestion(this.reference, this.selected)
      .then((response) => {
        this.options = response.data.Appointments;
        this.$bvModal.show("AppointmentSuccessModal");
        this.$emit("rescheduled", this.selected);
      })
      .catch((error) => {
        this.$bvModal.hide("RescheduleDateModal");
        this.$bvModal.show("AppointmentErrorModal");
      })
      .finally(() => {
        this.$bvModal.hide("RescheduleDateModal");
      });
  }

  private hideRescheduleDate() {
    this.$bvModal.hide("RescheduleDateModal");
  }
}
